import React from 'react';
import propTypes from 'prop-types';
import { getCompany } from 'helpers/getCompanyVariables';
import { Stack, TextField } from '@mui/material';
import AutocompleteInput from 'components/Autocomplete/AutocompleteInput';

const company = getCompany();

const isSunshine = company === 'sunshine';

export default function StateSelector({
  formData,
  options = [],
  handleChangeAppointments
}) {
  return (
    <>
      {isSunshine && (
        <p className='text-left leading-tight'>
          Select states you want to request, then click {'"Send request"'} to
          request your appointments.
        </p>
      )}

      <Stack spacing={5} sx={{ width: '100%', mb: 3, mt: 2 }}>
        <AutocompleteInput
          multiple
          showScrollbar
          value={formData.appointments}
          label='Select States'
          placeholder='Search'
          options={Array.isArray(options) ? options : []}
          onValueChanges={handleChangeAppointments}
          listBoxProps={{
            style: {
              maxHeight: 250
            }
          }}
          renderInput={params => (
            <TextField
              {...params}
              label='Select States'
              placeholder='Select States'
              error={formData.appointments.length === 0}
              helperText={
                formData.appointments.length === 0
                  ? 'You need to select at least 1 state'
                  : ''
              }
              InputLabelProps={{
                shrink: true
              }}
            />
          )}
        />
      </Stack>
    </>
  );
}

StateSelector.propTypes = {
  formData: propTypes.object.isRequired,
  options: propTypes.array.isRequired,
  handleChangeAppointments: propTypes.func.isRequired
};
